import {FC} from 'react';
import {useTranslation} from 'react-i18next';

import Link from '@/components/link';
import {BUTTON_THEME, BUTTON_VARIANT} from '@/constants/button';
import {ALLOCATION_ACCOUNT_TYPE_TO_DV_MAPPING} from '@/constants/engine';
import {useConfig} from '@/contexts/config';
import {Allocation, AllocationAccountType} from '@/repositories/beneva-api/endpoints/allocations';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';
import Button from '../button';

type Props = {
  allocation: Allocation;
  onRowDeleteClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const AllocationRow: FC<Props> = ({allocation, onRowDeleteClick}) => {
  const {t} = useTranslation();
  const {domainValueResolver} = useConfig();

  return (
    <div
      className="flex items-center border-b border-b-grey-400 last:border-b-0 hover:bg-grey-400/20"
      key={allocation.id}
    >
      <Link
        to={`/app/profile/allocations/edit/${allocation.id}`}
        className="grid grow grid-cols-6 p-4"
        aria-label={t('components.advisor-predetermined-allocations.edit-allocation.accessibility-label', {
          allocationName: allocation.name,
        })}
        trackingKey={WEB_CLICK_TRACKING_KEY.EDIT_ALLOCATION}
      >
        <div className="col-span-3 flex items-center gap-4 text-center">{allocation.name}</div>
        <div className="col-span-2 flex items-center gap-4 text-center">
          {domainValueResolver({
            $ref: ALLOCATION_ACCOUNT_TYPE_TO_DV_MAPPING[allocation.accountType ?? AllocationAccountType.CI],
          })}
        </div>

        <div className="flex justify-end">
          <Button
            theme={BUTTON_THEME.SECONDARY}
            variant={BUTTON_VARIANT.X_SMALL}
            label={t('components.advisor-predetermined-allocations.delete')}
            onClick={onRowDeleteClick}
            trackingKey={WEB_CLICK_TRACKING_KEY.DELETE_ALLOCATION}
          />
        </div>
      </Link>
    </div>
  );
};
